import { number, object, string } from 'yup';

const date = () => object({
  day: number(),
  year: number(),
  month: number(),
});

export const leave = object({
  fromDate: date().required().label('تاریخ شروع'),
  toDate: date().required().label('تاریخ پایان'),
  address: string().required().label('آدرس'),
  phoneNumber: string().required().label('شماره تلفن'),
  mobileNumber: string().required().label('شماره موبایل'),
  relation: string().required().label('نسبت'),
  description: string().default('').label('توضیحات').optional(),
});

export function getPreRegisterFormValidation(dormitoryIdRequired: boolean) {
  let dormitoryIdSchema = number().required().integer();
  if (!dormitoryIdRequired) {
    dormitoryIdSchema = dormitoryIdSchema.nullable();
  }
  return object({
    dormitoryId: dormitoryIdSchema,
    description: string().optional(),
  });
}

export const leaveSync = {
  async validator(rule: any, value: any) {
    const { field } = rule;
    return await leave.validateSyncAt(field, { [field]: value });
  }
};
